import React from 'react';
//import $ from 'jquery';
//import classNames from "classnames";
import {connect} from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import './ProductPresetPanel.scss';

import {setPresetDesignOption} from '../../actions';

//css and images

class ProductPresetPanel extends React.PureComponent {

    constructor(props, context) {
        super(props, context);
        this.state = {
            preset: props.preset,
        };
        this.handleCustomizeClicked = this.handleCustomizeClicked.bind(this);
    }

    handleCustomizeClicked(option, label, selected, event) {
        event.preventDefault();
        event.stopPropagation();
        if (selected) {
            return false;
        }
        if (!this.props.preset || ('object' !== typeof this.props.preset) || !Object.keys(this.props.preset).length) {
            return false;
        }
        this.props.setPresetDesignOption(option, label);
        this.setState({
            preset: this.props.preset,
        });
    }

    render() {
        const params = {
            items: 4,
            nav: true,
            rewind: false,
            autoplay: false,
            //lazyLoad: true,
            dots: false,
            loop: false,
            //singleItem: true,
            //autoWidth:true,
            navText: ['&lt;', '&gt;'],
            responsive: {
                0: {
                    items: 3,
                },
                576: {
                    items: 3,
                },
                769: {
                    items: 4,
                },
                376: {
                    items: 4,
                }
            }

        };
        // console.log('preset', this.props.preset, this.state.preset)

        if (!this.props.preset || ('object' !== typeof this.props.preset) || !Object.keys(this.props.preset).length) {
            return '';
        }
        let preset = this.props.preset;
        let self = this;
        return (<React.Fragment>
                {
                    Object.keys(preset).map(
                        function (label) {
                            let options = preset[label];


                            let found = 0;
                            let option = options[found];
                            let json = (option.json && 'string' === typeof option.json) ? JSON.parse(option.json ? option.json : null) : option.json;

                            let JsonLength = 0;
                            if (json) {
                                if (Array.isArray(json)) {
                                    JsonLength = json.length;
                                } else {
                                    JsonLength = Object.keys(json).length;
                                }

                            } else if (!option.json || !json || !JsonLength) {
                                return '';
                            }
                            if (json[0]) {
                                for (let page of self.props.pages) {
                                    for (let element of page.elements) {
                                        if (('object' === typeof element)
                                            && found < JsonLength
                                            && found + 1 >= Math.abs(option.position)
                                            && (element.type === json[found].type)
                                        ) {
                                            ++found;
                                            break;
                                        }
                                    }
                                    if (found) break;
                                }

                                if (!found) return '';
                            }

                            return (
                                <React.Fragment key={label}>
                                    <div className="row">
                                        <div className="col-3 h6 font-weight-bold">
                                            {label}
                                        </div>
                                        <div className="col-9">
                                            <OwlCarousel ref="car" options={params}
                                                         className="border-0 owl-carousel owl-theme owl-loaded owl-drag border px-4 py-2 owl-preset owl-grab">
                                                {
                                                    Object.keys(options).map(index => {
                                                        let option = options[index];

                                                        return <div key={option.id}>
                                                            <img data-src={option.preview} src={option.preview}
                                                                 alt={option.caption} name={option.caption}
                                                                 ref={'preset-' + option.id} width={100}
                                                                 className={'border' + (option.selected ? ' selected' : '')}
                                                                 onClick={self.handleCustomizeClicked.bind(this, option, label, option.selected)}/>
                                                        </div>
                                                    })
                                                }
                                            </OwlCarousel>
                                        </div>
                                        <div className="w-100 d-block border-top mt-2">&nbsp;</div>
                                    </div>
                                </React.Fragment>
                            )
                        })
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    // let currentDesignBackground = null;
    // if (state.currentProjectOptions && state.projectOptions && state.projectOptions.images) {
    //     let imageData = state.projectOptions.images.find((image) => {
    //         let match = true;
    //         for (let option in state.currentProjectOptions) {
    //             let variation = state.currentProjectOptions[option];
    //             if (image[option] != variation) {
    //                 match = false;
    //                 break;
    //             }
    //         }
    //         return match;
    //     })
    //     if (imageData) {
    //         currentDesignBackground = imageData;
    //     }
    // }
    //
    // let previewPage = 0;
    // if (currentDesignBackground && currentDesignBackground.previews && state.previewPage && currentDesignBackground.previews[state.previewPage]) {
    //   previewPage = state.previewPage
    // }
    //console.log(state.projectOptions?state.projectOptions.preset:[]);


    return {
        //pages: state.pages,
        // currentDesignBackground: currentDesignBackground,
        // previewPage: previewPage,
        preset: state.projectOptions ? state.projectOptions.preset : [],
        //    projectOptions: state.projectOptions,
        //currentProjectOptions: state.currentProjectOptions,
        pages: Object.keys(state.pages).map(function (key) {
            return state.pages[key];
        }),
        customTexts: state.customTexts,
        projectCode: state.projectCode,
    };
};

const mapDispatchToProps = dispatch => ({
    setPresetDesignOption: (json, label) => dispatch(setPresetDesignOption(json, label)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPresetPanel);


